import { APP_CONFIG } from '../../../../config/appConfig';

// APP_CONFIG.API_BASE_URL already ends in "/api" — paths below must not repeat it.
const BASE_URL = APP_CONFIG.API_BASE_URL;

async function request(path, options = {}) {
  const res = await fetch(`${BASE_URL}${path}`, {
    credentials: 'include',
    headers: { 'Content-Type': 'application/json' },
    ...options,
  });
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    throw new Error(data.error || `Request failed (${res.status})`);
  }
  return data;
}

function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== '' && v !== null)
  );
}

export const adminApi = {
  listUsers: (params) => request(`/admin/users?${new URLSearchParams(cleanParams(params))}`),
  getUser: (uid) => request(`/admin/users/${uid}`),
  grantSubscription: (uid, body) =>
    request(`/admin/users/${uid}/grant-subscription`, { method: 'POST', body: JSON.stringify(body) }),
  removeSubscription: (uid) => request(`/admin/users/${uid}/remove-subscription`, { method: 'POST' }),
  banUser: (uid, reason) => request(`/admin/users/${uid}/ban`, { method: 'POST', body: JSON.stringify({ reason }) }),
  unbanUser: (uid) => request(`/admin/users/${uid}/unban`, { method: 'POST' }),
  suspendUser: (uid) => request(`/admin/users/${uid}/suspend`, { method: 'POST' }),
  unsuspendUser: (uid) => request(`/admin/users/${uid}/unsuspend`, { method: 'POST' }),
  updateUserFields: (uid, body) =>
    request(`/admin/users/${uid}/update-fields`, { method: 'POST', body: JSON.stringify(body) }),

  getTotalUsers: () => request('/admin/statistics/total-users'),
  getTotalRevenue: () => request('/admin/statistics/total-revenue'),
  getActivePlans: () => request('/admin/statistics/active-plans'),
  getReferralCommissions: () => request('/admin/statistics/referral-commissions'),
  getUserAnalytics: () => request('/admin/statistics/user-analytics'),
  getSurveyBreakdown: () => request('/admin/statistics/survey-breakdown'),
  getWithdrawals: () => request('/admin/withdrawals/withdrawals'),

  getActivityOnline: () => request('/admin/activity/online'),
  getActivityOverview: (days) => request(`/admin/activity/overview?${new URLSearchParams(cleanParams({ days }))}`),
  getActivityFunnel: (days) => request(`/admin/activity/funnel?${new URLSearchParams(cleanParams({ days }))}`),
  getActivityErrors: (params) => request(`/admin/activity/errors?${new URLSearchParams(cleanParams(params))}`),
  getActivityEvents: (params) => request(`/admin/activity/events?${new URLSearchParams(cleanParams(params))}`),
  getFingerprintMatches: (hash) => request(`/admin/activity/fingerprint/${hash}`),
  getUserSessions: (uid) => request(`/admin/activity/sessions/${uid}`),
  getVisitors: (params) => request(`/admin/activity/visitors?${new URLSearchParams(cleanParams(params))}`),
  getVisitor: (id) => request(`/admin/activity/visitors/${id}`),

  getFraudGroups: () => request('/admin/fraud/groups'),
  getAccountGraph: (uid) => request(`/admin/fraud/account-graph/${uid}`),
  browseFingerprints: (params) => request(`/admin/fraud/fingerprints?${new URLSearchParams(cleanParams(params))}`),
  getFlaggedSignups: (params) => request(`/admin/fraud/flagged?${new URLSearchParams(cleanParams(params))}`),
  getFraudTimeline: (hash) => request(`/admin/fraud/timeline/${hash}`),
  getFraudStats: (days) => request(`/admin/fraud/stats?${new URLSearchParams(cleanParams({ days }))}`),
  mergeFingerprint: (body) => request('/admin/fraud/merge', { method: 'POST', body: JSON.stringify(body) }),
  unmergeFingerprint: (body) => request('/admin/fraud/unmerge', { method: 'POST', body: JSON.stringify(body) }),
  fullBanUser: (uid, reason) => request(`/admin/fraud/full-ban/${uid}`, { method: 'POST', body: JSON.stringify({ reason }) }),
  fullUnbanUser: (uid) => request(`/admin/fraud/full-unban/${uid}`, { method: 'POST' }),
  banDevice: (body) => request('/admin/fraud/ban-device', { method: 'POST', body: JSON.stringify(body) }),
};
